/**
 * If url is an absolute URL pointing to localhost/127.0.0.1 and the app
 * is running on a different origin (e.g. production), returns the same path
 * but with the current origin. Otherwise returns url unchanged.
 * Use so links and QR codes work when dashboardUrl was set during local dev.
 */
export function normalizePuzzleUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const trimmed = url.trim();
  if (!trimmed) return trimmed;

  // Relative path (starts with /) – use as-is so it resolves to current origin
  if (trimmed.startsWith('/')) return trimmed;

  const currentOrigin = window.location.origin;
  const hostname = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
  const isOnLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isOnLocalhost) return trimmed; // Already on localhost, no rewrite

  // Detect stored localhost URLs by string so we never miss them
  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(trimmed)) {
    try {
      const parsed = new URL(trimmed);
      return currentOrigin + parsed.pathname + parsed.search + parsed.hash;
    } catch (_) {
      const pathPart = trimmed.replace(/^https?:\/\/[^/]+/i, '') || '/';
      return currentOrigin + pathPart;
    }
  }

  return trimmed;
}
